export type PlaceListVisibility = 'public' | 'unlisted' | 'private';

export function getVisibilityLabel(visibility: PlaceListVisibility): string {
    const labels: Record<PlaceListVisibility, string> = {
        public: 'Public',
        unlisted: 'Unlisted',
        private: 'Private',
    };

    return labels[visibility];
}
